import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["href"]
const _hoisted_4 = { style: {"display":"inline-block"} }
const _hoisted_5 = { style: {"clear":"both"} }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "player-votes" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["href"]
const _hoisted_11 = { style: {"display":"inline-block"} }
const _hoisted_12 = { style: {"clear":"both"} }
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "player-votes" }
const _hoisted_16 = {
  key: 1,
  style: {"display":"flex","flex-direction":"row","flex":"1"}
}
const _hoisted_17 = { style: {"line-height":"70px","display":"inline-block","width":"45px","height":"70px","text-align":"center","font-size":"large"} }
const _hoisted_18 = { style: {"position":"relative"} }
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 1,
  style: {"text-align":"center","line-height":"70px","width":"70px"}
}
const _hoisted_21 = {
  key: 2,
  style: {"position":"absolute","top":"50%","left":"50%","transform":"translate(-50%, -50%)"}
}
const _hoisted_22 = { style: {"white-space":"nowrap","font-size":"larger","-webkit-text-stroke":"1px silver","font-weight":"bolder","position":"absolute","top":"78%","left":"50%","transform":"translate(-50%, -50%)","text-align":"center"} }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center","line-height":"70px","margin-left":"20px","margin-right":"20px"} }, "vs", -1)
const _hoisted_24 = { style: {"position":"relative"} }
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  key: 1,
  style: {"position":"absolute","top":"50%","left":"50%","transform":"translate(-50%, -50%)"}
}
const _hoisted_27 = {
  key: 2,
  style: {"white-space":"nowrap","font-size":"larger","-webkit-text-stroke":"1px silver","font-weight":"bolder","position":"absolute","top":"78%","left":"50%","transform":"translate(-50%, -50%)","text-align":"center"}
}
const _hoisted_28 = {
  key: 0,
  style: {"text-align":"center","line-height":"70px","width":"70px"}
}
const _hoisted_29 = { style: {"line-height":"70px","display":"inline-block","width":"50px","height":"70px","text-align":"center","font-size":"large"} }

import { onMounted, ref } from 'vue';
import _ from 'lodash';
import { bracketService } from '@/services/bracket.service';
import { onUnmounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Match',
  props: ['match', 'round', 'index', 'voting', 'currenteVoteRound', 'actualRound'],
  emits: ['vote'],
  setup(__props, { emit }) {

const props = __props;




let selected: Record<string, any> = ref({});

function urlClicked($event, url) {
    $event.preventDefault();
    $event.stopImmediatePropagation();
    window.open(url, '_blank');
    return false;
}

function vote(id: string) {
    if (!props.voting) {
        return;
    }

    if (/^bye$/i.test(props.match.player2.name)) {
        return;
    }

    let voteVal = !selected.value[id];
    selected.value = {};
    selected.value[id] = voteVal;
    const evt = {
        roundId: props.actualRound,
        matchId: props.match.id,
        playerId: id,
    };

    emit('vote', evt);
}

function isLost(id: number) {
    if (props.currenteVoteRound <= props.round) {
        if(props.match.player2.name === 'Bye') {
            return id;
        }
        return false;
    }

    if (id) {
        return props.match.player2.votes <= props.match.player1.votes;
    } else {
        return props.match.player1.votes < props.match.player2.votes;
    }
}

function isBye() {
  return props.match.player2.name === 'Bye';  
}

function isWon(id: number) {
    if (props.currenteVoteRound <= props.round) {
        if(props.match.player2.name === 'Bye') {
            return !id;
        }
        return false;
    }

    if (id) {
        return props.match.player2.votes > props.match.player1.votes;
    } else {
        return props.match.player1.votes >= props.match.player2.votes;
    }
}



let votesSub = bracketService.getVotes().subscribe((votes) => {
    let bFound1 = _.find(votes, (v) => v == props.match.player1.id);
    let bFound2 = _.find(votes, (v) => v == props.match.player2.id);
    if (bFound1) {
        selected.value = {};
        selected.value[props.match.player1.id] = true;
    } else if (bFound2) {
        selected.value = {};
        selected.value[props.match.player2.id] = true;
    }
});

onUnmounted(() => {
    votesSub?.unsubscribe();
})

onMounted(async () => {

    console.log('started');
});


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    style: {"display":"block","width":"300px"},
    class: _normalizeClass({ 'voting': props.voting })
  }, [
    (!props.match.player1.thumbnail && !props.match.player2.thumbnail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["player-cell", { 'selected': _unref(selected)[props.match.player1.id] }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (vote(props.match.player1.id)))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass([{ 'lost': isLost(0) }, "player-name"])
            }, [
              (_unref(selected)[props.match.player1.id])
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    color: "green",
                    icon: "mdi-check-bold"
                  }))
                : _createCommentVNode("", true),
              (props.match.player1.url)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _createTextVNode(" ( "),
                    _createElementVNode("a", {
                      href: props.match.player1.url,
                      target: "_blank",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (urlClicked($event, props.match.player1.url)))
                    }, " link ", 8, _hoisted_3),
                    _createTextVNode(" ) ")
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(props.match.player1.name), 1),
                (props.match.player1.thumbnail)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: props.match.player1.thumbnail,
                      style: {"float":"left","height":"30px","width":"30px"}
                    }, null, 8, _hoisted_6))
                  : _createCommentVNode("", true)
              ]),
              (props.match.player1.name.length >= 29 || props.match.player1.thumbnail)
                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                    key: 2,
                    activator: "parent",
                    location: "start"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", null, _toDisplayString(props.match.player1.name), 1),
                      (props.match.player1.thumbnail)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: props.match.player1.thumbnail
                          }, null, 8, _hoisted_7))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", _hoisted_8, _toDisplayString(props.voting ? '??' : props.match.player1.votes ?? 0), 1)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["player-cell", { 'selected': _unref(selected)[props.match.player2.id] }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (vote(props.match.player2.id)))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass([{ 'lost': isLost(1) }, "player-name"])
            }, [
              (_unref(selected)[props.match.player2.id])
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    color: "green",
                    icon: "mdi-check-bold"
                  }))
                : _createCommentVNode("", true),
              (props.match.player2.url)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    _createTextVNode(" ( "),
                    _createElementVNode("a", {
                      href: props.match.player2.url,
                      target: "_blank",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (urlClicked($event, props.match.player2.url)))
                    }, " link ", 8, _hoisted_10),
                    _createTextVNode(" ) ")
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(props.match.player2.name), 1),
                (props.match.player2.thumbnail)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: props.match.player2.thumbnail,
                      style: {"float":"left","height":"30px","width":"30px"}
                    }, null, 8, _hoisted_13))
                  : _createCommentVNode("", true)
              ]),
              (props.match.player2.name.length >= 29 || props.match.player2.thumbnail)
                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                    key: 2,
                    activator: "parent",
                    location: "start"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", null, _toDisplayString(props.match.player2.name), 1),
                      (props.match.player2.thumbnail)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: props.match.player2.thumbnail
                          }, null, 8, _hoisted_14))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", _hoisted_15, _toDisplayString(props.voting ? '??' : props.match.player2.votes ?? 0), 1)
          ], 2)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, _toDisplayString((props.voting && !isBye()) ? '??' : props.match.player1.votes ?? 0), 1),
          _createElementVNode("div", {
            style: {"height":"70px"},
            class: _normalizeClass(["player-cell-img", { 'selected': _unref(selected)[props.match.player1.id], 'lost': isLost(0), 'won': isWon(0)  }]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (vote(props.match.player1.id)))
          }, [
            _createElementVNode("div", _hoisted_18, [
              (props.match.player1.thumbnail)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: props.match.player1.thumbnail,
                    style: {"height":"70px","width":"70px"}
                  }, null, 8, _hoisted_19))
                : _createCommentVNode("", true),
              (!props.match.player1.thumbnail)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Winner"))
                : _createCommentVNode("", true),
              (_unref(selected)[props.match.player1.id])
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    (_unref(selected)[props.match.player1.id])
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          color: "green",
                          icon: "mdi-check-bold",
                          size: "xxx-large"
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_22, _toDisplayString(props.match.player1.name), 1)
            ]),
            _createVNode(_component_v_tooltip, {
              activator: "parent",
              location: "start"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$props.match.player1.name), 1)
              ]),
              _: 1
            })
          ], 2),
          _hoisted_23,
          _createElementVNode("div", {
            class: _normalizeClass(["player-cell-img", { 'selected': _unref(selected)[props.match.player2.id], 'lost': isLost(1), 'won': isWon(1)  }]),
            style: {"height":"70px"},
            onClick: _cache[5] || (_cache[5] = ($event: any) => (vote(props.match.player2.id)))
          }, [
            _createElementVNode("div", _hoisted_24, [
              (_ctx.$props.match.player2.thumbnail)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: props.match.player2.thumbnail,
                    style: {"height":"70px","width":"70px"}
                  }, null, 8, _hoisted_25))
                : _createCommentVNode("", true),
              (_unref(selected)[props.match.player2.id])
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    (_unref(selected)[props.match.player2.id])
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          color: "green",
                          icon: "mdi-check-bold",
                          size: "xxx-large"
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (props.match.player2.thumbnail)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(props.match.player2.name), 1))
                : _createCommentVNode("", true)
            ]),
            (!props.match.player2.thumbnail)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, "Bye"))
              : _createCommentVNode("", true),
            _createVNode(_component_v_tooltip, {
              activator: "parent",
              location: "start"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, _toDisplayString(props.match.player2.name), 1)
              ]),
              _: 1
            })
          ], 2),
          _createElementVNode("div", _hoisted_29, _toDisplayString((props.voting && !isBye()) ? '??' : props.match.player2.votes ?? 0), 1)
        ]))
  ], 2))
}
}

})